import { Router } from '@okapi/router-react';
import React from 'react';
import { StoreContext } from 'storeon/react';
import { Baseline } from 'common/components';
import { AdplatformTraining } from 'landings/adplatform-training';
import { RemoteProps } from './widgets-types';

export const AdplatformTrainingRemote: React.FC<RemoteProps> = ({ router, store }) => (
  /* @ts-expect-error: Router typecheck error */
  <Router router={router}>
    <Baseline>
      <StoreContext.Provider value={store}>
        <AdplatformTraining />
      </StoreContext.Provider>
    </Baseline>
  </Router>
);
